require('es6-promise').polyfill();
import axios from 'axios'
axios.defaults.timeout = 80000
    // code状态码200判断
axios.interceptors.response.use((res) => {
    // console.log(res);
    if (res.status === 654) { // 百度云请求超时检测
        res = { Result: false, Message: "请求超时！" };
    }
    if (res.status !== 200) {
        res = { Result: false, Message: "服务器返回错误！" };
    }
    if(res.data.status == "0"){
        return res.data;
    }
    if (!res.data.Message) {
        res = { Result: res.data.Result, Data: res.data.Data };
    } else {
        res = { Result: res.data.Result, Message: res.data.Message };
    }

    return res
}, (error) => {
    console.log('promise error:' + error)
    return Promise.reject(error)
})
export default axios


// WEBPACK FOOTER //
// ./src/utils/diyaxios.js